import React, {useEffect, useState} from 'react'
import {Card} from "antd";
import {Calendar, momentLocalizer} from "react-big-calendar";
import {getCalendarProduction} from "../../services/serviceProduction";
import "react-big-calendar/lib/css/react-big-calendar.css"
import moment from "moment";

const localizer = momentLocalizer(moment)

const ProductionCalendar = () => {

    const [events, setEvents] = useState([])
    const culture = 'tr'

    useEffect(() => {
        getCalendarProduction()
            .then(({data}) => {
                mutateForCalendar(data)
            })
    }, [])

    const mutateForCalendar = (list) => {
        let data = list.map(item => {
            const startDateStr = item.startDate.slice(0, 10)
            const endDateStr = item.endDate.slice(0, 10)

            return {
                id: item.id,
                start: new Date(startDateStr),
                end: new Date(endDateStr),
                title: `Müşteri: ${item.customer.name} - Reçete: ${item.recipe.name}`,
                desc: item.note
            }
        })
        setEvents(data)
    }

    return (
        <React.Fragment>
            <Card
                title={'Üretim Takvimi'}
            >
                <Calendar
                    style={{height: '65vh'}}
                    localizer={localizer}
                    defaultDate={new Date()}
                    culture={culture}
                    events={events}
                    popup
                />
            </Card>
        </React.Fragment>
    )
}
export default ProductionCalendar